import { createAction } from 'redux-actions';
import { THREAD_PRESENCE_UPDATED } from '../constants/ActionTypes';
export const presenceUpdated = createAction(THREAD_PRESENCE_UPDATED, ({
  threadId,
  message
}) => ({
  threadId,
  message
}));